import React from "react";
import { Link } from "react-scroll";
import { scrollDuration } from "../../../config/commonConfig";
import resumeFile from "../../../documents/resume.pdf";

const StandardMenuDefaultIntro = () => {
  return (
    <section id="home" className="bg-primary d-flex fullscreen-with-header position-relative">
      <div className="container my-auto py-5 py-lg-0">
        <div className="row py-4">
          <div className="col-lg-7 text-center text-lg-start align-self-center order-1 order-lg-0">
            <h1 className="text-10 fw-400 mb-2">توسعه‌دهنده و لید فنی</h1>
            <h2 className="text-16 fw-600 mb-3 ms-n1">برای ساخت و تحویل محصول واقعی</h2>
            <p className="text-5 mb-2">
              طراحی معماری، توسعه Web و Mobile، استقرار و پشتیبانی؛ از ایده و نیازمندی تا نسخه‌ی قابل‌استفاده.
            </p>
            <p className="text-5">
              همکاری دقیق، گزارش‌پذیر و متمرکز بر خروجی؛ مناسب کسب‌وکارها و تیم‌هایی که دنبال اجرای قابل‌اعتماد هستند.
            </p>
            <p className="text-center text-lg-start mt-4 wow fadeInUp">
              <Link
                className="btn btn-dark rounded-5 smooth-scroll mt-2 me-2"
                smooth="easeInOutQuint"
                duration={scrollDuration}
                style={{ cursor: "pointer" }}
                to="portfolio"
              >
                مشاهده پروژه‌های منتخب
              </Link>
              <a className="btn btn-outline-dark rounded-5 mt-2" href={resumeFile} download>
                دانلود رزومه
              </a>
            </p>
          </div>
          <div className="col-lg-5 text-center align-self-center mb-4 mb-lg-0 order-0 order-lg-1">
            <div className="bg-light rounded-pill d-inline-block p-3 shadow-lg wow zoomIn">
              <img
                className="img-fluid rounded-pill d-block"
                src="images/web-developer.jpg"
                title="Sina Khanjani"
                alt="Sina Khanjani"
              />
            </div>
          </div>
        </div>
      </div>
      <Link
        className="scroll-down-arrow text-dark smooth-scroll"
        smooth="easeInOutQuint"
        duration={scrollDuration}
        style={{ cursor: "pointer" }}
        to="about"
      >
        <span className="animated">
          <i className="fas fa-arrow-down" />
        </span>
      </Link>
    </section>
  );
};

export default StandardMenuDefaultIntro;
